export default stage => {
    let cmsRoot = 'lni.wa.gov/';
    if (stage === 'integration') {
        cmsRoot = `dev-public.${cmsRoot}`;
    } else if (stage === 'pre-production') {
        cmsRoot = `demo-public.${cmsRoot}`;
    }

    return `https://${cmsRoot}`;
};